import request from '@/utils/request'

//获取教学实验课列表
export function getmyarrangedlist(params) {
    return request({
      url: '/portal/course-lib-timetable/get-my-arranged-list',
      method: 'GET',
      params
    })
  }